import React, { Component } from 'react';
import Docs from "../docs/docs";
import Settings from '../settings/settings';
import CreateAccount from '../create-account/create-account';
import CreateFilter from '../create-filter/create-filter';
import { isDocs, isSettings, getSessionToken, isFilterUrl } from '../../services/backend-service';

class MainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      context: props.context || {}
    };
  }

  render() {
    if(isDocs() || !getSessionToken()) {
      return <Docs />;
    } if(isSettings()) {
      return <Settings />;
    } else {
      if(isFilterUrl()) {
        return <CreateFilter />;
      } else {
        return <CreateAccount />;
      }
    }
  }
}

export default MainGrid;
